import { render, staticRenderFns } from "./Rule_13cardsPoker.vue?vue&type=template&id=07cf4a88&scoped=true&"
import script from "./Rule_13cardsPoker.vue?vue&type=script&lang=js&"
export * from "./Rule_13cardsPoker.vue?vue&type=script&lang=js&"
import style0 from "./Rule_13cardsPoker.vue?vue&type=style&index=0&id=07cf4a88&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cf4a88",
  null
  
)

export default component.exports